var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "vx-card",
    [
      _c(
        "dir",
        [
          _c(
            "vs-row",
            [
              _c(
                "vs-col",
                { attrs: { "vs-align": "left", "vs-w": "6" } },
                [
                  _c(
                    "DialogPrompt",
                    {
                      attrs: {
                        active: _vm.showPopup,
                        title: _vm.getDataPrompt.title,
                        "cancel-text": "Fermer",
                        "accept-text": "Enregistrer",
                        "button-accept": _vm.getDataPrompt.btnAccept,
                        "is-valid": !_vm.formError,
                      },
                      on: {
                        "update:active": function ($event) {
                          _vm.showPopup = $event
                        },
                        cancel: _vm.resetResource,
                        accept: _vm.storeResource,
                        close: _vm.resetResource,
                      },
                    },
                    [
                      _vm.formType == "select"
                        ? _c("SectorForm", {
                            attrs: { type: _vm.formType },
                            on: { error: _vm.setFormError },
                            model: {
                              value: _vm.resource,
                              callback: function ($$v) {
                                _vm.resource = $$v
                              },
                              expression: "resource",
                            },
                          })
                        : _vm.formType == "show"
                        ? _c("OccupationSkillForm", {
                            attrs: { type: _vm.formType },
                            model: {
                              value: _vm.resource,
                              callback: function ($$v) {
                                _vm.resource = $$v
                              },
                              expression: "resource",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("vs-col", {
                attrs: { "vs-type": "flex", "vs-align": "left", "vs-w": "6" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "vs-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                sst: true,
                search: "",
                multiple: "",
                "no-data-text": _vm.loading
                  ? `Chargement de vos données...`
                  : `Aucune donnée à afficher`,
                data: _vm.items.data,
              },
              on: {
                search: _vm.eventSearchItems,
                input: _vm.selectedInputHandle,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ data }) {
                    return _vm._l(data, function (item, i) {
                      return _c(
                        "vs-tr",
                        { key: i, attrs: { data: item, "data-id": item.id } },
                        [
                          _c(
                            "vs-td",
                            {
                              attrs: {
                                data: _vm.get(item, ":title"),
                                title: _vm.get(item, ":description"),
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "text-wrap": "nowrap",
                                    display: "flex",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "float-left mr-5",
                                      staticStyle: { "line-height": "25px" },
                                    },
                                    [_vm._v(_vm._s(_vm.get(item, ":title")))]
                                  ),
                                  _vm._v(" "),
                                  item.is_new
                                    ? _c(
                                        "vs-chip",
                                        {
                                          staticClass: "bg-chip-transparent",
                                          attrs: { color: "warning" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Nouveau\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.beta_status == true
                                    ? _c("vs-chip", [
                                        _vm._v(
                                          "\n                                Bêta\n                            "
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  item.tenant_used == true
                                    ? _c(
                                        "vs-chip",
                                        {
                                          staticClass: "bg-chip-transparent",
                                          attrs: { color: "success" },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Utilisé\n                            "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "vs-td",
                            {
                              staticStyle: { "min-width": "152px" },
                              attrs: { data: _vm.get(item, ":type") },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.get(item, ":type")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "vs-td",
                            {
                              staticStyle: { "min-width": "270px" },
                              attrs: { data: _vm.get(item, ":sector") },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.get(item, ":sector.title")) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "vs-td",
                            _vm._l(
                              item.admin_occupations,
                              function (adminOccupation, i) {
                                return _c("vs-chip", { key: i }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(adminOccupation.title) +
                                      "\n                        "
                                  ),
                                ])
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "vs-td",
                            {
                              staticClass: "action",
                              staticStyle: { "min-width": "160px" },
                            },
                            [
                              _c("vs-button", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Consulter",
                                    expression: "'Consulter'",
                                  },
                                ],
                                attrs: {
                                  size: "small",
                                  color: "primary",
                                  type: "border",
                                  "icon-pack": "feather",
                                  icon: "icon-list",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.showResource(item)
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("vs-button", {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: "Télécharger le savoir-faire",
                                    expression: "'Télécharger le savoir-faire'",
                                  },
                                ],
                                attrs: {
                                  size: "small",
                                  color: "primary",
                                  type: "border",
                                  "icon-pack": "feather",
                                  icon: "icon-download",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.downloadParent(item)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    })
                  },
                },
              ]),
              model: {
                value: _vm.selected,
                callback: function ($$v) {
                  _vm.selected = $$v
                },
                expression: "selected",
              },
            },
            [
              _c(
                "template",
                { slot: "header" },
                [
                  _c(
                    "vs-row",
                    [
                      _vm.isASuperAdmin() || _vm.isAnAdmin()
                        ? _c(
                            "vs-col",
                            {
                              attrs: {
                                "vs-type": "flex",
                                "vs-align": "left",
                                "vs-w": "6",
                              },
                            },
                            [
                              _c(
                                "vs-checkbox",
                                {
                                  attrs: { name: "filterByNew" },
                                  model: {
                                    value: _vm.filterByNew,
                                    callback: function ($$v) {
                                      _vm.filterByNew = $$v
                                    },
                                    expression: "filterByNew",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Nouveautés\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "vs-checkbox",
                                {
                                  attrs: { name: "filterByUsed" },
                                  model: {
                                    value: _vm.filterByUsed,
                                    callback: function ($$v) {
                                      _vm.filterByUsed = $$v
                                    },
                                    expression: "filterByUsed",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            Utilisé\n                        "
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              !_vm.selected.length
                ? _c(
                    "template",
                    { slot: "thead" },
                    [
                      _c(
                        "vs-th",
                        [
                          _c(
                            "Sort",
                            {
                              attrs: { name: "title" },
                              on: { sort: _vm.eventSortByCol },
                            },
                            [_vm._v("Libellé")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-th",
                        [
                          _c(
                            "Sort",
                            {
                              attrs: { name: "type" },
                              on: { sort: _vm.eventSortByCol },
                            },
                            [_vm._v("Type")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-th",
                        [
                          _c(
                            "Sort",
                            {
                              attrs: { name: "sector,title" },
                              on: { sort: _vm.eventSortByCol },
                            },
                            [_vm._v("Filière")]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("vs-th", [
                        _vm._v(
                          "\n                    Métier(s) centralisé(s)\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("vs-th"),
                    ],
                    1
                  )
                : _c(
                    "template",
                    { slot: "thead" },
                    [
                      _c(
                        "vs-th",
                        { attrs: { colspan: "2" } },
                        [
                          _c("span", { staticClass: "selected-lines mr-5" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.selectedLinesText) +
                                "\n                    "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "vs-checkbox",
                            {
                              attrs: { name: "selectAll" },
                              on: { input: _vm.selectAllItemsHandle },
                              model: {
                                value: _vm.selectAll,
                                callback: function ($$v) {
                                  _vm.selectAll = $$v
                                },
                                expression: "selectAll",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        Sélectionner la totalité des lignes\n                    "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-th",
                        {
                          staticStyle: { "font-weight": "400" },
                          attrs: { colspan: "1" },
                        },
                        [
                          _c(
                            "Multiselect",
                            {
                              attrs: {
                                options: _vm.massActionList,
                                multiple: false,
                                "group-select": false,
                                placeholder: "Choisir une action...",
                                "track-by": "id",
                                label: "label",
                                "select-label": "",
                                "select-group-label": "",
                                "selected-label": "",
                                "deselect-label": "",
                                "deselect-group-label": "",
                                "open-direction": "bottom",
                              },
                              model: {
                                value: _vm.massAction,
                                callback: function ($$v) {
                                  _vm.massAction = $$v
                                },
                                expression: "massAction",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  attrs: { slot: "noResult" },
                                  slot: "noResult",
                                },
                                [_vm._v("Aucun résultat.")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "vs-th",
                        [
                          _vm.canDoMassAction()
                            ? _c(
                                "vs-button",
                                {
                                  attrs: {
                                    color: "secondary",
                                    type: "filled",
                                    "icon-pack": "feather",
                                    icon: "icon-check",
                                    size: "large",
                                  },
                                  on: { click: _vm.massActionHandle },
                                },
                                [
                                  _vm._v(
                                    "\n                        Valider\n                    "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "vs-row",
            [
              _vm.items.total > 0
                ? _c(
                    "vs-col",
                    { staticClass: "mt-4" },
                    [
                      _c("vs-pagination", {
                        attrs: {
                          total: Math.ceil(
                            _vm.items.total / _vm.apiParams.perpage
                          ),
                        },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }